export const ROUTER_PATHS = {
  login: '/',
  home: '/home',
  deviceAuth: '/deviceAuth',
  inspection: {
    root: '/inspection',
    basicInfo: 'basicInfo',
    buildingInfo: 'buildingInfo',
    step1: 'step1',
    step2: 'step2',
    result: 'result'
  }
}
